import { render, staticRenderFns } from "./RadiobuttonWrapper.vue?vue&type=template&id=edb19c32&"
import script from "./RadiobuttonWrapper.vue?vue&type=script&lang=js&"
export * from "./RadiobuttonWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports